import http from 'ctrlbox'
import { setUrl } from '@/utils/url'
const api = 'sso'

// 获取验证码
export const sendMyCode = (params) => http.get(setUrl('/account/sendCode'), { params })
// 获取验证码
export const sendCode = (params) => http.get(setUrl('/auth/sendCode', api), { params })
// 获取邮箱验证码
export const sendEmailCode = (params) => http.get(setUrl('/auth/sendEmailCode', api), { params })
// 校验公司名称
export const checkMerchantName = (params) => http.get(setUrl('/auth/checkMerchantName', api), { params })
// 校验手机号
export const checkloginNo = (params) => http.get(setUrl('/auth/loginNoIsExist', api), { params })
// 校验手机号
export const checkValidCode = (params) => http.get(setUrl('/auth/checkValidCode', api), { params })
// 注册功能
export const signup = (params) => http.post(setUrl('/auth/register', api), params)
// 登录功能
export const newSignin = (params) => http.post(setUrl('/oauth/token', api), params)
// 验证手机号是否存在
export const checkTel = (params) => http.get(setUrl('/auth/checkLoginNo', api), { params })
// 忘记密码
export const reset = (params) => http.post(setUrl('/auth/resetPassword', api), params)
// 强制重置密码
export const postSsoUpdatePassword = (params) => http.post(setUrl('/auth/updatePassword', api), params)

// 最近五次的密码
export const checkPassRepeat = (params) => http.post(setUrl('/auth/checkPassRepeat', api), params)
// 个人中心校验是否输入的是最近五次的密码
export const checkPassWord = (params) => http.post(setUrl('/account/checkPassRepeat'), params)

// 查询跳转地址(域名)
export const getDomainList = () => http.get(setUrl('/auth/domain', api))
// 验证码
export const checkCaptcha = (params) => http.get(setUrl('/auth/checkCaptcha', api), params)


//个人信息
export const getPersonalInfo = (params) => http.get(setUrl('/account/info'), { params })
//个人中心信息
export const getOwnerInfo = (params) => http.get(setUrl('/employee/headInfo'), { params })

//用户头像上传
export const postUpdateAvatar = (params) => http.post(setUrl('/account/updateAvatar'), params)

//是否是当前登录人的个人中心
export const getCheck = (params) => http.get(setUrl('/common/check'), { params })
//修改密码
export const postUpdatePassword = (params) => http.post(setUrl('/account/updatePassword'), params)
//修改登录账号
export const postUpdateMobile = (params) => http.post(setUrl('/account/updateMobile'), params)

// 获取部门成员
export const deptUser = params => http.get(setUrl('/employee/list'), { params })

//获取部门树列表
export const getDeptList = (params) => http.get(setUrl('/dept/list'), { params })

export const getUser = (params) => http.get(setUrl('/common/user'), { params })
// 工作日报 - 获取草稿列表（不分页）
export const getDraftList = (params) => http.get(setUrl('/daily/query'), { params })
// 工作日报 - 做废
export const postDailyScrapped = (params) => http.post(setUrl('/daily/detail/scrapped'), params)
// 工作日报 - 撤回
export const postRecall = id => http.post(setUrl(`/daily/detail/${id}/recall`))

// 工作日报 - 获取提交列表（分页）
export const getDailyList = (params) => http.get(setUrl('/daily/queryPage'), { params })
// 工作日报 - 获取详情接口
export const getDailyDetail = (params) => http.get(setUrl('/daily/detail/query'), { params })
// 工作日报 - 获取生成日报数据
export const createTodayDaily = (params) => http.get(setUrl('/daily/detail/queryTran'), { params })
// 工作日报 - 生成日报提交接口
export const saveTodayDaily = (params) => http.post(setUrl('/daily/detail/create'), params)
// 工作目标 - 获取草稿列表(不分页)
export const getWorkDraftList = (params) => http.get(setUrl('/employee/workGoal/draftList'), { params })
// 工作目标 - 获取工作目标列表(分页)
export const getWorkList = (params) => http.get(setUrl('/employee/workGoal/list'), { params })
// 工作目标 - 删除草稿
export const deleteWorkDraft = id => http.post(setUrl(`/employee/work/${id}/delete`))
// 工作目标 - 做废
export const postWorkScrapped = (params) => http.post(setUrl('/employee/work/scrapped'), params)
// 工作目标 - 新增接口
export const saveWork = params => http.post(setUrl('/employee/work/create'), params)
// 工作目标 - 修改接口
export const updateWork = params => http.post(setUrl('/employee/work/update'), params)
// 工作目标 - 撤回
export const postWorkRecall = id => http.post(setUrl(`/employee/work/${id}/recall`))

// 获取系统全部用户列表
export const getSysUserList = params => http.get(setUrl('/user/queryIdAndNamePageList'), { params })
// 任职信息 - 获取登录用户任职信息
export const getEmployeeInfo = params => http.get(setUrl('/employee/info'), { params })
// 个人档案 - 获取个人档案信息
export const getPersonalDoc = params => http.get(setUrl('/personDoc/info'), { params })
// 个人档案 - 修改个人档案信息
export const postUpdatePersonDoc = params => http.post(setUrl('/personDoc/update'), params)
// 工作日报 - 删除日报
export const deletedDaily = id => http.post(setUrl(`/daily/delete/${id}`))
// 工作日报
export const updateDaily = params => http.post(setUrl('/daily/detail/update'), params)
// 工作日报 - 写评论
export const addDailyComment = params => http.post(setUrl('/daily/comment/create'), params)
// 工作日报 - 分享同事圈
export const shareDailyToMoments = params => http.post(setUrl('/dynamic/create'), params)
// 工作日报 - 获取评论列表
export const getDailyComments = params => http.get(setUrl('/daily/comment/list'), { params })
// 工作日报 - 回复列表
export const getReplyList = params => http.get(setUrl('/daily/answer/comment/list'), { params })
// 工作日报 - 评论回复
export const postReplyComment = params => http.post(setUrl('/daily/answer/comment/create'), params)
// 工作日报 - 评论回复的回复
export const postReply = params => http.post(setUrl('/daily/comment/reply/createReply'), params)

// 查询回答评论列表
export const getCommentList = (params) => http.get(setUrl('/daily/comment/list'), { params })
// 新建评论
export const postCreateComment = (params) => http.post(setUrl('/daily/comment/create'), params)
// 查询回答评论列表
export const getAnswerCommentList = (params) => http.get(setUrl('/daily/answer/comment/list'), { params })
// 写评论
export const postCreateAnswerComment = (params) => http.post(setUrl('/daily/answer/comment/create'), params)
// 新建回复
export const postCreateReply = (params) => http.post(setUrl('/daily/comment/reply/createReply'), params)

// 工作日报 - 检查登录用户是否为本人
export const validUser = params => http.get(setUrl('/auth/check'), { params })

// 邮件
export const postMailSend = (params) => http.post(setUrl('/mail/send'), params)
// 点击事务标题跳转先调用这个方法标识已读
export const affairOperation = params => http.post(setUrl('/affairOperation/create'), params)

/** 下载文件 */
export const downloadFile = (params) => http.get('/api/filecenter/download', params)
//文件上传前
export const checkFile = (params) => http.post('/api/filecenter/upload/checkFile', params)
//文件上传时
export const checkChunkMd5 = (params) => http.post('/api/filecenter/upload/checkChunk', params)
//文上传成功
export const fileMerge = (params) => http.post('/api/filecenter/upload/merge', params)
// 上传文件合并
export const postMergeFile = (params) => http.post('/api/filecenter/upload/mergeFile', params)
// 小文件上传
export const postUploadSingleFile = (params) => http.post('/api/filecenter/upload/singleFile', params)

export const getSsoUrl = (params) => http.get('/api/ssoUrl', { params })

export const getWxToken = params => http.get('/api/sso/auth/wx/getWxToken', { params })

export const postWxOpenId = params => http.get(setUrl('/wx/user/saveWxOpenId'), { params })

export const postUntie = params => http.post(setUrl('/wx/user/untie'), params)
// 判断是否需要域登录
export const getLdap = (params) => http.get('/api/ldap', { params })

// 登录页面判断logo
export const getSysLogo = (params) => http.get('/api/sysLogo', { params })
// 钉钉绑定
export const getDingUrl = (params) => http.get('/api/authcenter/account/ding/scanning/url', { params })
// 飞书绑定
export const getFeiUrl = (params) => http.get('/api/authcenter/account/fei/scanning/url', { params })
// 企业微信绑定
export const getQwUrl = (params) => http.get('/api/authcenter/account/qw/scanning/url', { params })
// 钉钉解绑
export const getDingUnbind = (params) => http.get('/api/authcenter/account/ding/unbind', { params })
// 飞书解绑
export const getFeiUnbind = (params) => http.get('/api/authcenter/account/fei/unbind', { params })
// 企业微信解绑
export const getQwUnbind = (params) => http.get('/api/authcenter/account/qw/unbind', { params })
// 钉钉登录
export const getDingUrlSingn = (params) => http.get('/api/sso/auth/ding/scanning/url', { params })
// 飞书登录
export const getFeiUrlSingn = (params) => http.get('/api/sso/auth/fei/scanning/url', { params })
// 企业微信登录
export const getQwUrlSingn = (params) => http.get('/api/sso/auth/qw/scanning/url', { params })

// 钉钉应用跳转
export const getDingApplicationLogin = (params) => http.get('/api/sso/auth/ding/application/login', { params })
// 获取appid接口
export const getThirdConfig = (params) => http.get('/api/sso/auth/third/config', { params })
// 转跳飞书接口
export const getFeiApplicationLogin = (params) => http.get('/api/sso/auth/fei/application/login', { params })


// SSO列表
export const getSsoQueryPage = (params) => http.get('/api/cloud/linksso/queryPage', { params })
// SSO列表
export const getLoginSsoList = (params) => http.get('/api/cloud/linksso/loginSsoList', { params })
// SSO删除
export const postLinkSsoDelete = (params) => http.post('/api/cloud/linksso/loginSso/delete', params)


// WEBPACK FOOTER //
// ./src/service/getData.js